import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/home/Hero';
import { Problems } from '../components/home/Problems';
import { About } from '../components/home/About';
import { Method } from '../components/home/Method';
import { Services } from '../components/home/Services';
import { FreeResources } from '../components/home/FreeResources';
import { Testimonials } from '../components/home/Testimonials';
import { Footer } from '../components/Footer';
import { SectionDivider } from '../components/ui';
import { CTAProvider } from '../components/CTAContext';
const navLinks = [{
  label: 'Despre noi',
  target: 'despre'
}, {
  label: 'Metoda 4R',
  target: 'metoda'
}, {
  label: 'Servicii',
  target: 'servicii'
}];
export const Acasa = () => {
  return <CTAProvider config={{
    mode: 'whatsapp'
  }} data-id="element-500">
      <div className="min-h-screen bg-navy text-textLight font-sans selection:bg-gold/30 selection:text-white" data-id="element-501">
        <Header links={navLinks} enrollTarget="servicii" data-id="element-502" />
        <Hero data-id="element-503" />
        <SectionDivider data-id="element-504" />
        <Problems data-id="element-505" />
        <SectionDivider data-id="element-506" />
        <About data-id="element-507" />
        <SectionDivider data-id="element-508" />
        <Method data-id="element-509" />
        <SectionDivider data-id="element-510" />
        <Services data-id="element-511" />
        <FreeResources data-id="element-512" />
        <Testimonials data-id="element-513" />
        <Footer data-id="element-514" />
      </div>
    </CTAProvider>;
};